


























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import type { Trade } from '@/models/trade';
import type { Phase } from '@/models/phase';
import type { Lesson } from '@/models/lesson';
import type { Worksheet } from '@/models/worksheet';
import type { Project } from '@/models/project';

import { tradeWorksheetWebservice } from '@/webservices/tradeWorksheet';
import { tradeWorksheetWebserviceV2 } from '@/webservices/v2/tradeWorksheet';
import { phaseWebservice } from '@/webservices/phase';
import { tradeWebservice } from '@/webservices/trade';
import type { Topic } from '@/models/topic';
import { topicWebservice } from '@/webservices/topic';
import { topicWebserviceV2 } from '@/webservices/v2/topic';
import { ApprovalState } from '@/components/prine/enums/ApprovalState';
import PrineButton from '@/components/prine/PrineButton.vue';
import LessonsList from '@/components/knowledge/lessons/LessonsList.vue';
import type { User } from '@/models/user';
import UpdateFilter from '@/components/worksheets/UpdateFilter.vue';
import { extractTagsFrom } from '@/helpers/extractTags';
import { LessonsFilter } from '@/helpers/types/LessonsFilter';
import { filterLessonContainer, filterLessons } from '@/helpers/filter/lessons/lessonsFilter';
import { allInLessonContainersSelected } from '@/helpers/filter/lessons/allInLessonContainersSelected';
import { deselectAll, selectAll } from '@/helpers/filter/lessons/selectAll';

@Component({
    name: 'CreateWorksheetTrade',
    methods: { extractTagsFrom },
    components: {
        UpdateFilter,
        PrineButton,
        LessonsList,
    },
})
export default class CreateWorksheetTrade extends Vue {
    private filters: LessonsFilter = {
        tags: [],
    };
    private checkedLessons = new Array<Lesson>();
    private topics = new Array<Topic>();
    private filteredTopics = new Array<Topic>();

    private tradeId;
    private phaseId;
    private selectedTrade: Trade = {} as Trade;
    private selectedPhase: Phase = {} as Phase;

    private worksheet: Worksheet = {} as Worksheet;
    private isLoading: boolean = false;

    @Getter('project/selectedProject') private selectedProject: Project;

    @Getter('account/userInfo') private userInfo: User;

    @Watch('filters', { deep: true })
    private filterLessons() {
        this.filteredTopics = filterLessonContainer(JSON.parse(JSON.stringify(this.topics)) as Topic[], this.filters);
    }

    get allSelected() {
        return allInLessonContainersSelected(this.filteredTopics, this.checkedLessons);
    }

    private mounted() {
        if (this.$route.query.hasOwnProperty('tradeId') && this.$route.query.hasOwnProperty('phaseId')) {
            // The id is passed as string, parse it
            this.tradeId = Number.parseInt(this.$route.query.tradeId.toString(), 10);
            this.phaseId = Number.parseInt(this.$route.query.phaseId.toString(), 10);
            this.loadTrade();
            this.loadPhase();
        } else {
            this.goBack();
        }
    }

    private goBack() {
        this.$router.go(-1);
    }

    private loadPhase() {
        const self = this;

        phaseWebservice.getById(this.phaseId).then((response) => {
            self.selectedPhase = response.data;
        });
    }

    private loadTrade() {
        const self = this;

        tradeWebservice.getById(this.tradeId).then((response) => {
            self.selectedTrade = response.data;

            // Load all lessons when the trade is loaded
            self.loadLessons();
        });
    }

    private loadLessons() {
        // get List With Questions By tradeId With Lessons and phases
        // tslint:disable-next-line:max-line-length
        topicWebservice
            .loadTopicsByTradeAndPhaseWithLessons(this.tradeId, this.phaseId, ApprovalState.APPROVED)
            .then((response) => {
                this.topics = response.data;
                this.filterLessons();

                if (this.userInfo.company_id === this.selectedProject.company_id) {
                    // get List With Questions By tradeId With Lessons and phases
                    // tslint:disable-next-line:max-line-length
                    topicWebservice
                        .loadTopicsByTradeAndPhaseWithLessons(this.tradeId, this.phaseId, ApprovalState.APPROVED)
                        .then((response2) => {
                            this.topics = response2.data;
                            this.filterLessons();
                            this.preselectMandatoryLessons();
                        })
                        .catch((error) => {
                            console.error(error);
                        });
                } else {
                    // get List With Questions By trade Id With Lessons and phases
                    // tslint:disable-next-line:max-line-length
                    topicWebserviceV2
                        .loadTopicsByTradeAndPhaseWithLessons(this.phaseId, ApprovalState.APPROVED)
                        .then((response2) => {
                            this.topics = response2.data;
                            this.filterLessons();
                            this.preselectMandatoryLessons();
                        })
                        .catch((error) => {
                            console.error(error);
                        });
                }
            });
    }

    private preselectMandatoryLessons() {
        this.topics.forEach((topic) => {
            this.selectLessonsIfMandatory(topic.lessons);
        });
    }

    private selectLessonsIfMandatory(lessons: Lesson[]) {
        lessons.forEach((lesson: Lesson) => {
            if (lesson.mandatory) {
                this.checkedLessons.push(lesson);
            }
            if (lesson.sub_lessons && lesson.sub_lessons.length > 0) {
                this.selectLessonsIfMandatory(lesson.sub_lessons);
            }
        });
    }

    private selectAllClick() {
        if (this.allSelected) {
            this.checkedLessons = deselectAll(this.filteredTopics, this.checkedLessons);
        } else {
            this.checkedLessons = selectAll(this.filteredTopics, this.checkedLessons);
        }
    }

    private createWorksheetTrade() {
        let webservice = tradeWorksheetWebserviceV2;
        if (this.userInfo.company_id === this.selectedProject.company_id) {
            webservice = tradeWorksheetWebservice;
        }

        this.isLoading = true;
        this.worksheet.phase = this.selectedPhase;
        this.worksheet.trade = this.selectedTrade;
        this.worksheet.project = this.selectedProject;

        console.log(this.worksheet);

        webservice
            .store(this.worksheet, this.checkedLessons)
            .then((response) => {
                // Store the worksheet id
                this.worksheet.id = response.data;

                // Show the Worksheet View
                this.$router.push({
                    name: 'WorksheetView',
                    query: {
                        id: this.worksheet.id.toString(),
                    },
                });
            })
            .catch((error) => {
                console.log(error);
                this.isLoading = false;
            });
    }

    private hr(index) {
        return index > 1;
    }
}
